import * as React from 'react';

interface IProps {
    modal: string;
    label: string;
    title: string;
    modalTitle: string;
    warningMsg: string;
    callback: () => void;
};

const handleYes = (props:IProps) => {
    document.getElementsByTagName('body')[0].classList.remove('modal-open');
    let modalBackdrops = document.getElementsByClassName('modal-backdrop');
    for (let i = 0; i < modalBackdrops.length; i++) {
        modalBackdrops[i].parentNode.removeChild(modalBackdrops[i]);
    }
    props.callback();
};

const CourseDeleteModal = (props:IProps) => (
    <div
        className='modal fade'
        id={props.modal}
        role='dialog'
        aria-labelledby={props.label}
        aria-hidden='true'>
        <div className='modal-dialog'>
            <div className='modal-content'>
                <div className='modal-header'>
                    <button type='button' className='close' data-dismiss='modal' aria-hidden='true'>
                        &times;
                    </button>
                    <h4 className='modal-title'>{props.modalTitle}</h4>
                </div>
                <div className='modal-body'>{`${props.warningMsg}${props.title}`}?</div>
                <div className='modal-footer'>
                    <button type='button' className='btn btn-default' data-dismiss='modal'>No</button>
                    <button
                        type='button'
                        data-dismiss='modal'
                        onClick={() => handleYes(props)}
                        className='btn btn-danger'>
                        Yes
                    </button>
                </div>
            </div>
        </div>
    </div>
);

export default CourseDeleteModal;
